<template>
  <div class="elective-score-entry-top-bar">
    <!-- 操作栏容器 -->
    <div class="elective-info-operation-container">
      <div class="elective-info-search-container">
        <!-- 搜索框 -->
        <!-- <search
          class="search"
          :placeholder="'请输入活动名称'"
          @search="electiveNameSearch"
        /> -->
        <div class="select-item">
          <el-select v-model="searchInfo.studentId" clearable filterable placeholder="请选择学生" @change="studentChange">
            <el-option v-for="(item, index) in gradeStudentList" :key="index" :label="item.studentName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <el-select v-model="searchInfo.courseId" clearable filterable placeholder="请选择科目" @change="courseChange">
            <el-option v-for="item in schoolCourseList" :key="item.id" :label="item.courseName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="select-item">
          <!-- <el-date-picker
            v-model="searchInfo.schoolYear"
            type="year"
            placeholder="选择学年"
            value-format="yyyy"
            @change="schoolYearChange"
          >
          </el-date-picker> -->
          <year-range-picker style="width: 250px;" v-model="searchInfo.schoolYear" />
        </div>
        <div class="select-item">
          <el-select v-model="searchInfo.semester" clearable placeholder="选择学期" @change="semesterChange">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="elective-info-button-container">
        <el-button type="primary" round size="medium" @click="scoreEntryClick"
          v-hasPermi="'sc:electivegrade:add'">录入成绩</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 搜索框
import search from "@/components/search/search.vue";
export default {
  props: ["semesterOptions", "semester", "schoolYear", "gradeStudentList", "schoolCourseList"],
  components: {
    search,
  },
  data() {
    return {
      searchInfo: {
        semester: "",
        schoolYear: "",
        studentId: "",
        courseId: "",
      },
    };
  },
  mounted() {
    setTimeout(() => {
      this.searchInfo.semester = this.semester;
      this.searchInfo.schoolYear = this.schoolYear;
      // console.log("this.searchInfo:", this.searchInfo);
    }, 500);
  },
  methods: {
    studentChange(e) {
      this.$emit("search", this.searchInfo);
    },
    courseChange(e) {
      this.$emit("search", this.searchInfo);
    },
    schoolYearChange(e) {
      // console.log(this.searchInfo);
      this.$emit("search", this.searchInfo);
    },
    semesterChange(e) {
      // console.log(this.searchInfo);
      this.$emit("search", this.searchInfo);
    },
    // electiveNameSearch(e) {},
    scoreEntryClick() {
      this.$emit("scoreEntryClick", true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./electiveScoreEntryTopBar.scss";
</style>